import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { ModalModule } from '@avla/ui-design';
import { ComponentModule } from './component/component.module';

const modules: any[] = [ComponentModule];

@NgModule({
  declarations: [
  ],
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    ModalModule,
    modules,
  ],
  exports: [modules],
  providers: [],
})
export class SharedModule {}
